import { useConfig } from '@occc/config';

import RetailerNetworkMyStoresPage from './retailer-network-my-stores-page';
import RetailerNetworkMyStoresV2Page from './retailer-network-my-stores-v2-page';

export const RetailerNetworkMyStoresVersionSwitch = () => {
  const { config } = useConfig();

  return config.retailerConnectRedesignV2.enabled ? (
    <RetailerNetworkMyStoresV2Page />
  ) : (
    <RetailerNetworkMyStoresPage />
  );
};
